import React, { Component } from 'react';
import {Button, Checkbox, Form, Input, List, Popover, Select} from "antd";
const {Option} = Select;
const { TextArea } = Input;

class CollectionDetails extends Component{
    constructor(props) {
        super(props);
        this.state={
            collection_checked:false,
        }
    }
    onChange=(v)=>{
        this.setState({collection_checked:v.target.checked})
        this.props.SKID(v.target.checked)
    }
    render() {
        const {collection_checked} = this.state;
        let list = JSON.parse(window.sessionStorage.getItem('we_country_Texts'))
        return <div className="spaceBox">
            <Form.Item
                label="Collection Details"
                style={{fontWeight: 'bold'}}
            >
            </Form.Item>
            <Form.Item
                labelCol={{ span: 19}}
                wrapperCol={{ span: 10}}
                label="Collection from Customer not needed (units at Venray)"
                name="CollectionDetailsNotRequired"
                rules={[{ required: false}]}
            >
                <Checkbox onChange={this.onChange}></Checkbox>
            </Form.Item>
            {collection_checked?
                <div>
                    <Form.Item
                        label="SKID"
                        name={'contactPersonCity'}
                        rules={[{ required: false }]}
                    >
                        <Input maxLength={40} />
                    </Form.Item>
                </div>
                :
                <div>
                    <Form.Item
                        label="Contact Person"
                        name={'contactPerson'}
                        rules={[{ required: true }]}
                    >
                        <Input maxlength={40} />
                    </Form.Item>
                    <Form.Item
                        label="Phone Number"
                        name={'contactPersonPhone'}
                        rules={[{ required: false}]}
                    >
                        <Input maxLength={30} />
                    </Form.Item>
                    <Form.Item
                        label="Email Address"
                        name={'contactPersonEmail'}
                        rules={[{ required: true }]}
                    >
                        <Input maxLength={200} />
                    </Form.Item>
                    <Form.Item
                        label="Company"
                        name={'contactPersonCompany'}
                        rules={[{ required: true }]}
                    >
                        <Input maxLength={50} />
                    </Form.Item>
                    <Form.Item
                        label="Street"
                        name={'contactPersonStreet'}
                        rules={[{ required: true }]}
                    >
                        <Input maxLength={60} />
                    </Form.Item>
                    <Form.Item
                        label="Zip Code"
                        name={'contactPersonZipCode'}
                        rules={[{ required: true }]}
                    >
                        <Input maxLength={10} />
                    </Form.Item>
                    <Form.Item
                        label="City"
                        name={'contactPersonCity'}
                        rules={[{ required: true }]}
                    >
                        <Input maxLength={40} />
                    </Form.Item>
                    <Form.Item
                        label="Country"
                        name={'contactPersonCountry'}
                        rules={[{ required: true}]}
                    >
                        <Select placeholder='Please select'>
                            {
                                list[0].sort((a, b) => {
                                    return a.countryText.charCodeAt(0)-b.countryText.charCodeAt(0)
                                }).map((item)=>{
                                    return <Option value={item.country} >{item.countryText}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                </div>
            }

        </div>
    }

}

export default CollectionDetails;